module.exports = __webpack_public_path__ + "media/6.adebeb41.wav";